// ============================================================================
// Book multistop pickup — standalone tab. Enter one or more PO numbers (the first is the first
// pickup) to open the multistop flow: quote validates the set + suggests other same-customer POs to
// club, ops orders the stops by number, then books one Delhivery order that collects from every
// vendor and drops at the single customer. Reuses the DelhiveryMultistopModal launched elsewhere, so
// there's one source of truth for the booking UI. Admin + delivery-team only (gated at route + nav).
// ============================================================================
import { Button, Card, Input, Space, Typography } from "antd";
import React from "react";
import DelhiveryMultistopModal from "../oms/logistics/delhivery_multistop_modal";

const { Title, Text } = Typography;

// Split on commas / whitespace / newlines, trim, drop blanks, dedupe — order preserved.
const parsePoNumbers = (raw: string): string[] => {
  const seen = new Set<string>();
  return raw
    .split(/[\s,]+/)
    .map((s) => s.trim())
    .filter((s) => {
      if (!s || seen.has(s)) return false;
      seen.add(s);
      return true;
    });
};

const DelhiveryMultistop: React.FC = () => {
  const [poInput, setPoInput] = React.useState("");
  // The POs seeding the open modal (empty = closed).
  const [activePos, setActivePos] = React.useState<string[]>([]);

  const parsed = parsePoNumbers(poInput);
  const openModal = () => {
    if (parsed.length > 0) setActivePos(parsed);
  };

  return (
    <div style={{ padding: 24, maxWidth: 720 }}>
      <Title level={3}>Book multistop pickup</Title>
      <Text type="secondary">
        Enter the PO numbers to collect for one customer — the first is the first pickup. The quote
        checks the set, suggests other same-customer POs you can club in, and lets you order the
        stops before booking a single Delhivery pickup.
      </Text>

      <Card style={{ marginTop: 16 }}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            placeholder="PO numbers — comma or space separated (e.g. MD9202684949, MD9202684981)"
            value={poInput}
            onChange={(e) => setPoInput(e.target.value)}
            onPressEnter={openModal}
            allowClear
          />
          <Button type="primary" disabled={parsed.length === 0} onClick={openModal}>
            Open
          </Button>
        </Space.Compact>
        {parsed.length > 0 && (
          <Text type="secondary" style={{ display: "block", marginTop: 8, fontSize: 12 }}>
            {parsed.length} PO{parsed.length === 1 ? "" : "s"} — first pickup: {parsed[0]}
          </Text>
        )}
      </Card>

      <DelhiveryMultistopModal
        poNumbers={activePos}
        open={activePos.length > 0}
        onClose={() => setActivePos([])}
      />
    </div>
  );
};

export default DelhiveryMultistop;
